function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCitibank = function SvgCitibank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 26",
    style: {
      enableBackground: "new 0 0 40 26"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1358ed"
    },
    d: "M0 0h40v26H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.84 15.86c-.585.585-1.235.91-1.95.91-1.43 0-2.405-1.04-2.405-2.47s1.04-2.47 2.405-2.47c.65 0 1.3.325 1.885.91l.065.065.91-1.105c-.78-.91-1.625-1.3-2.73-1.3s-2.145.39-2.86 1.04c-.91.585-1.3 1.625-1.3 2.86s.39 2.275 1.235 2.99c.715.65 1.755 1.04 2.86 1.04s2.015-.455 2.73-1.3l-.845-1.17zm1.755 2.275h1.56V10.4h-1.56v7.735zm7.865-1.69c-.455.26-.845.39-1.17.39-.52 0-.715-.26-.715-.845v-4.095H25.2V10.4h-1.625V7.995l-1.625.78V10.4h-1.3v1.495h1.3v4.355c0 1.17.715 2.015 1.755 2.015.715 0 1.17-.195 1.43-.325l.39-1.495h-.065zm1.3 1.69h1.625V10.4H26.76v7.735z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.295 9.035c-1.43-2.08-3.9-3.315-6.305-3.315a7.71 7.71 0 0 0-6.305 3.315l-.13.065h1.82a6.2 6.2 0 0 1 4.55-1.95 6.2 6.2 0 0 1 4.55 1.95h1.82v-.065z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ff220e"
    }
  }));
};
export default SvgCitibank;